export default __webpack_public_path__ + "static/sa-etape1-c1b03022bc70340828eeb2897d7e463e.jpeg";